import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer, SafeResourceUrl, SafeHtml} from '@angular/platform-browser';

@Pipe({
    name: 'sanitizeResource',
    standalone: true
})
export class NlrSanitizeResourcePipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {}

    transform(value?: string | null, type?: 'html' | 'url'): SafeHtml | SafeResourceUrl {
        if (!value) {
            return value;
        }

        switch (type) {
            case 'html':
                return this.sanitizer.bypassSecurityTrustHtml(value);
            case 'url':
                return this.sanitizer.bypassSecurityTrustResourceUrl(value);
            default:
                throw new Error(`sanitizeResource Pipe Error: Unsupported type '${type}'. Use 'html' or 'url'.`);
        }
    }
}
